@if ((toggleButton$ | async) && showFloatingActionButton) {
  <button
    mat-fab
    color="warn"
    [disabled]="(isCustomersPage$ | async) && this.customersSelected === 0"
    class="app-floating-review-request-button button-on-resize"
    (click)="handleClick()"
    >
    <div class="floating-button-content">
      <mat-icon class="floating-button-icon">send</mat-icon>
      <span class="floating-button-text">
        {{ 'CUSTOMERS.ACTION_BUTTON.SEND_REQUEST' | translate }}
      </span>
    </div>
  </button>
}
